Pegasus.TemplateController = Ember.ObjectController.extend({
  needs: [
    'toolbar',
    'editing',
    'mainTabPanel',
    'templatePreview',
    'themes',
    'autoSave',
    'viewOptions',
    'frameCommManager'
  ],

  isEditingCapturePalette: false,

  draggingMuted: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      console.log(value);
      return value;
    }

    return false;
  }.property(),
  isSaving: false,
  isStandalone: function(){
    return window === window.parent;
  }.property(),
  next: function(){
    if ( this.get('isSaving') ) { return; }
    this.set('isSaving', true);
    this.send('saveAndContinue');
  },
  exit: function(){
    if ( this.get('isSaving') ) { return; }
    this.set('isSaving', true);
    this.send('saveAndExit');
  },
  lastSaved: function(){
    return this.get('controllers.autoSave.lastSaved');
  }.property('controllers.autoSave.lastSaved'),
  forwardInstruction: function(){
    return Em.get(Pegasus, 'options.forwardInstruction');
  }.property('Pegasus.options'),
  shouldShowViewOnline: true,
  hasHidden: function(){
    return this.get('controllers.toolbar.hasHidden');
  }.property('controllers.toolbar.hasHidden'),
  revealHidden: false,
  toggleRevealHidden: function(){
    if ( this.get('revealHidden') ) {
      this.send('hideHidden');
    } else {
      this.send('showHidden');
    }

    this.toggleProperty('revealHidden');
  },
  currentZoomValue: function(){
    return this.get('controllers.viewOptions.zoomValue');
  }.property('controllers.viewOptions.zoomValue'),

  zoomClass: function(){
    return 'percent-' + this.get('currentZoomValue');
  }.property('currentZoomValue'),

  selectDocument: function(doc){
    var active = this.get('documents').filterProperty('id', doc.id).get('firstObject');
    this.set('activeDocument', active);
  },

  activeDocument: null,

  documents: [],

  documentsChanged: function(){
    if ( this.get('documents.length') === 1 ) {
      this.set('activeDocument', this.get('documents.firstObject'));
    }
  }.observes('documents.length'),

  didActivateFrame: function(frame, frames){
    this.get('controllers.frameCommManager').didActivateFrameOfFrames(frame, frames);
  },

  createSuccessDocument: function(){
    var baseDoc = this.get('documents.firstObject');
    var base = $.extend({}, baseDoc);
    base.id = 'success';
    base.name = Em.I18n.t('g.success_document');
    base.uniqueID = Em.generateGuid();

    this.get('documents').pushObject(base);
    Em.run.scheduleOnce('afterRender', null, function(){
      $('.document-tab.' + baseDoc.uniqueID).addClass('active');
    });
  },

  removeSuccessDocument: function(){
    var doc = this.get('documents').filterProperty('id', 'success').get('firstObject');
    this.get('documents').removeObject(doc);
  },

  hasMultipleDocuments: function(){
    return this.get('documents.length') > 1;
  }.property('documents.length')
});
